const getEnvValue = (key) => {
  return process.env[`REACT_APP_${key}`];
};

export const APP_NAME = getEnvValue('NAME');

export const API_URL = getEnvValue('API_URL');

export const ESAAD_NAME = getEnvValue('ESAAD_NAME');

export const ESAAD_CARD_API_URL = getEnvValue('ESAAD_CARD_API_URL');

export const API_KEY = getEnvValue('API_KEY');

export const PARTNERSHIP_URL=`${process.env.REACT_APP_PARTNERSHIP_PORTAL_URL}/api`;

export const MESSAGES = {
  ACCOUNT_REQUIRED: 'Please enter Carrefour Account',
  ACCOUNT_EMAIL: 'Please enter correct Carrefour Account',
  COMPANY_CODE_REQUIRED: 'Please enter Company Code',
  EMPLOYE_CODE_REQUIRED: 'Please enter Employee Code',
  LINK_CUSTOMER_SUCCESS: 'Information Linked Successfully!'
};

export const REGULAR_EXPRESSIONS = {
  email: /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/
};

export const HYPERMAX_COUNTRIES = ['JO', 'OM', 'KW', 'BH'];

export const ROUTES = {
  PARTNERSHIP_PORTAL: {
    ROOT: '/'
  },
  ADMIN_PAGE: {
    LOGIN: '/admin',
    HOME: '/home',
    UPDATE_PASSWORD: '/update-password'
  },
  ESAAD_CARD: {
    ROOT: '/esaad-card',
    OTP_VERIFY: '/esaad-card/verify',
    SUCCESS: '/esaad-card/verify/success',
    FAILURE: '/esaad-card/verify/fail'
  }
};

export const LANGUAGES = {
  ENGLISH: {
    langCode: 'en',
    language: 'English'
  },
  ARABIC: {
    langCode: 'ar',
    language: 'عربى'
  }
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const OTP_ACTIONS = {
  PARTNERSHIP_EMAIL_VERIFICATION: 'PARTNERSHIP_EMAIL_VERIFICATION',
};
